import { useDeepDiveContext } from '@src/providers/DeepDiveProvider';
import { Stack } from '@talos/kyoko';
import { NoMatchPage } from '../../../NoMatchPage';
import { MobileSymbolDeepDiveContent } from './MobileSymbolDeepDiveContent';
import { MobileSymbolDeepDiveFooter } from './MobileSymbolDeepDiveFooter';
import { MobileSymbolDeepDiveHeader } from './MobileSymbolDeepDiveHeader';

export function MobileSymbolDeepDiveView() {
  const { security } = useDeepDiveContext();

  if (!security) {
    return <NoMatchPage />;
  }

  return (
    <Stack background="backgroundContent" overflow="hidden" data-testid="mobile-symbol-deep-dive" w="100vw" flex="1">
      <MobileSymbolDeepDiveHeader security={security} />
      <MobileSymbolDeepDiveContent />
      <MobileSymbolDeepDiveFooter />
    </Stack>
  );
}
